import Vue from "vue";
import Router from "vue-router";

// import Register from "@/components/Register.vue";
// import Home from "@/components/Home.vue";
// import News from "@/components/News.vue";
// import Faq from "@/components/Faq.vue";
// import PrivacyPolicy from "@/components/PrivacyPolicy.vue";
// import TermOfService from "@/components/TermOfService.vue";
// import ForgetPassword from "@/components/ForgetPassword.vue";
// import Management from "@/components/Management.vue";

// const Register = () => import('@/components/Register')
const Home = () => import('@/components/Home')
const News = () => import('@/components/News')
const Faq = () => import('@/components/Faq')
const Tutorial = () => import('@/components/Tutorial')
const PrivacyPolicy = () => import('@/components/PrivacyPolicy')
const TermOfService = () => import('@/components/TermOfService')
const ForgetPassword = () => import('@/components/ForgetPassword')
const Management = () => import('@/components/Management')

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        guest: true,
      },
    },
    {
      path: "/management",
      name: "management",
      component: Management,
      meta: {
        guest: false,
        requiresAuth: true,
      },
    },
    {
      path: "/news",
      name: "news",
      component: News,
      meta: {
        guest: true,
      },
    },
    {
      path: "/faq",
      name: "faq",
      component: Faq,
      meta: {
        guest: true,
      },
    },
    {
      path: "/tutorial",
      name: "tutorial",
      component: Tutorial,
      meta: {
        guest: true,
      },
    },
    {
      path: "/privacy_policy",
      name: "privacy_policy",
      component: PrivacyPolicy,
      meta: {
        guest: true,
      },
    },
    {
      path: "/term_of_service",
      name: "term_of_service",
      component: TermOfService,
      meta: {
        guest: true,
      },
    },
    {
      path: "/forget_password",
      name: "forget_password",
      component: ForgetPassword,
      meta: {
        guest: true,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  //document.title = '青蛙集運 FrogiGo';
  console.log(to);
  if (to.path.startsWith("/deeplink/payment/")){
    //let url = new URL(window.location.href);
    //console.log(url);
    let [method, paymentId, status] = to.path.replace('/deeplink/payment/','').split('/');
    console.log(method, paymentId, status);
    next(`/management?PaymentID=${paymentId}&Method=${method}&Status=${status}`);
  } else if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (
      localStorage.getItem("access_token") == null ||
      localStorage.getItem("access_token") == ""
    ) {
      next("/");
    } else {
      next();
    }
  } else {
    next();
  }
});

const DEFAULT_TITLE = "ForgiGo 青蛙集運";
router.afterEach((to) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
});

export default router;
